import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
const GetProductNameBySku = graphql(`
  query GetProductNameBySku($sku: String!, $tenantId: ID!) {
    product {
      getVariants(tenantId: $tenantId, skus: [$sku], language: "no-nb") {
        product {
          name
        }
      }
    }
  }
`);
export default GetProductNameBySku;
